module.exports = __webpack_public_path__ + "img/纪念碑.20d8b066.png";